import React from "react";
import { Row } from "reactstrap";
import { ItemTouristic } from "./ItemTouristic";

export const CardTouristic = (props) => {
  const bgBtnColor = props.bgBtnColor;
  const itemsData = props.data;
  const routeDetail = props.routeDetail;
  const cards = itemsData.map((item) => (
    <ItemTouristic
      key={item.id}
      item={item}
      route={routeDetail}
      bgBtnColor={bgBtnColor}
    />
  ));
  return (
    <Row>
      {cards.length > 0 ? cards : <p>No se ha econtrado ningún registro.</p>}
    </Row>
  );
};
